'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _conversation = require('../store/actions/conversation');

var _app = require('../store/actions/app');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iconArrowRight = require('../image-strings/icon-arrow-right');

var _iconArrowRight2 = _interopRequireDefault(_iconArrowRight);

var _livePersonManager = require('../live-person-manager');

var _livePersonManager2 = _interopRequireDefault(_livePersonManager);

var _actionManager = require('../action-manager');

var _botUtils = require('../bot-utils');

var _loading = require('./loading');

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var maxInputLength = 256;

/**
 * Input
 * @returns {React.Element} Returns JSX of user input
 * @public
 */

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.userTypingTimeout = null;

    _this.onChange = _this.onChange.bind(_this);
    _this.onKeyPress = _this.onKeyPress.bind(_this);
    _this.submit = _this.submit.bind(_this);
    _this.updateHeight = _this.updateHeight.bind(_this);
    _this.getPlaceholderMessage = _this.getPlaceholderMessage.bind(_this);
    _this.handleValidationInput = _this.handleValidationInput.bind(_this);
    return _this;
  }

  _createClass(Input, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Necessary to reset textarea height after submitting a multi-line utterance
      if (this.props.messageText === '') {
        this.updateHeight();
      }

      if (!this.props.appBlocked && prevProps.appBlocked) {
        this.input.focus();
      }
    }

    /**
     * Handles changes to user message
     * removes html tags not used in dialog flow that otherwise would require special handling
     *
     * @param {Object} event The event object
     * @private
     */

  }, {
    key: 'onChange',
    value: function onChange(event) {
      var messageText = event.target.value.replace(/(<([^>]+)>)/ig, '');
      this.props.setMessageText(messageText);
      this.updateHeight();

      // Update live agent with user typing status
      // `setVisitorTyping` manages debouncing internally
      // so we don't have to worry about polluting network requests
      _livePersonManager2.default.setVisitorTyping(true);
      clearTimeout(this.userTypingTimeout);
      this.userTypingTimeout = setTimeout(function () {
        return _livePersonManager2.default.setVisitorTyping(false);
      }, 3000);
    }

    /**
     * Handles enter keypress event
     *
     * @param {Object} event The event object
     * @private
     */

  }, {
    key: 'onKeyPress',
    value: function onKeyPress(event) {
      if (event && event.key === 'Enter') {
        event.preventDefault();
        this.submit();
      }
    }
  }, {
    key: 'handleValidationInput',
    value: function handleValidationInput() {
      var _props = this.props,
          messageText = _props.messageText,
          triggerEvent = _props.triggerEvent,
          chatbotsApiBaseUrl = _props.chatbotsApiBaseUrl;

      var _ref = this.props.dialogFlow || {},
          validation = _ref.validation;

      if (validation) {
        var type = validation.type,
            action = validation.action,
            _validation$cancel = validation.cancel,
            cancel = _validation$cancel === undefined ? 'cancel-validation' : _validation$cancel,
            _validation$failed = validation.failed,
            failed = _validation$failed === undefined ? 're-enter' : _validation$failed,
            _validation$cancelTex = validation.cancelText,
            cancelText = _validation$cancelTex === undefined ? 'cancel' : _validation$cancelTex;

        var validator = (0, _botUtils.getValidator)(type);
        var takeAction = (0, _actionManager.getAction)(action);
        if (validator && validator(messageText)) {
          this.props.sendUserMessage();
          this.updateHeight();
          takeAction && takeAction(_extends({ messageText: messageText }, this.props.dialogFlow, { triggerEvent: triggerEvent, chatbotsApiBaseUrl: chatbotsApiBaseUrl }, validation));
          this.props.appDialogFlowSet({ validation: null });
        } else if (messageText && messageText.toLowerCase() === cancelText) {
          triggerEvent(cancel);
          this.props.setMessageText('');
          this.props.appDialogFlowSet({ validation: null });
        } else {
          this.props.conversationAppend({ msg: messageText, msgType: 'user' });
          this.props.setMessageText('');
          this.props.triggerEvent(failed);
        }
      }
    }

    /**
     * Submit user's utterance
     *
     * @private
     */

  }, {
    key: 'submit',
    value: function submit() {
      var _ref2 = this.props.dialogFlow || {},
          validation = _ref2.validation;

      if (!this.props.appBlocked) {
        if (!validation) {
          this.props.sendUserMessage();
          this.updateHeight();
        } else {
          this.handleValidationInput();
        }
      }
    }

    /**
     * Update height of textarea
     *
     * @private
     */

  }, {
    key: 'updateHeight',
    value: function updateHeight() {
      this.input.style.height = 'auto';
      this.input.style.height = this.input.scrollHeight + 'px';
    }
  }, {
    key: 'getPlaceholderMessage',
    value: function getPlaceholderMessage() {
      if (this.props.appBlocked) {
        return this.props.intl.formatMessage({ id: 'Support:HelpBot:Input:Wait' });
      }

      var _ref3 = this.props.dialogFlow || {},
          validation = _ref3.validation;

      if (validation && validation.inputPlaceholderText) {
        return validation.inputPlaceholderText;
      }
      return this.props.intl.formatMessage({ id: 'Support:HelpBot:Input:Message' });
    }

    /**
     * @returns {React.Element} render
     *
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'chatbot-input-container' },
        _react2.default.createElement('textarea', {
          ref: function ref(input) {
            _this2.input = input;
          },
          className: 'chatbot-input',
          placeholder: this.getPlaceholderMessage(),
          rows: 1,
          value: this.props.messageText,
          onChange: this.onChange,
          onKeyPress: this.onKeyPress,
          maxLength: maxInputLength,
          disabled: this.props.appBlocked
        }),
        _react2.default.createElement(
          'span',
          {
            onClick: this.submit,
            onKeyPress: this.onKeyPress,
            className: 'chatbot-input-submit',
            role: 'button',
            tabIndex: '0',
            title: 'Submit'
          },
          _react2.default.createElement('img', { src: _iconArrowRight2.default, alt: '' })
        ),
        this.props.liveAgentConnecting && _react2.default.createElement(
          'div',
          { className: 'chatbot-input-cover' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:LiveEngage:Connecting' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'chatbot-input-cover-loading' },
            _react2.default.createElement(_loading2.default, { dark: true })
          )
        )
      );
    }
  }]);

  return Input;
}(_react2.default.Component);

/**
 * Property definitions.
 *
 * @type {Object}
 * @private
 */


Input.propTypes = {
  appBlocked: _propTypes2.default.bool.isRequired,
  chatbotsApiBaseUrl: _propTypes2.default.string,
  dialogFlow: _propTypes2.default.object.isRequired,
  intl: _reactIntl.intlShape,
  liveAgentConnecting: _propTypes2.default.bool,
  messageText: _propTypes2.default.string,
  sendUserMessage: _propTypes2.default.func.isRequired,
  setMessageText: _propTypes2.default.func.isRequired,
  triggerEvent: _propTypes2.default.func.isRequired,
  conversationAppend: _propTypes2.default.func.isRequired,
  appDialogFlowSet: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appBlocked: state.app.blocked,
    dialogFlow: state.app.dialogFlow
  };
};

var mapDispatchToProps = {
  conversationAppend: _conversation.conversationAppend,
  appDialogFlowSet: _app.appDialogFlowSet
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Input));